export default __webpack_public_path__ + "static/media/25.5fd9df3d.jpg";